"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkNull = exports.useProvider = exports.connect = exports.findDerivedAccountWithBump = exports.findDerivedAccount = exports.Hooks = exports.bigIntToBn = exports.bnToBigInt = exports.bnToNumber = exports.AssociatedToken = exports.TokenFaucet = void 0;
const anchor_1 = require("@project-serum/anchor");
const pubkey_1 = require("@project-serum/anchor/dist/cjs/utils/pubkey");
const react_1 = require("react");
__exportStar(require("./tokenAmount"), exports);
__exportStar(require("./tokenMintKeys"), exports);
var tokenFaucet_1 = require("./tokenFaucet");
Object.defineProperty(exports, "TokenFaucet", { enumerable: true, get: function () { return tokenFaucet_1.TokenFaucet; } });
var associatedToken_1 = require("./associatedToken");
Object.defineProperty(exports, "AssociatedToken", { enumerable: true, get: function () { return associatedToken_1.AssociatedToken; } });
var accountParser_1 = require("./accountParser");
Object.defineProperty(exports, "bnToNumber", { enumerable: true, get: function () { return accountParser_1.bnToNumber; } });
Object.defineProperty(exports, "bnToBigInt", { enumerable: true, get: function () { return accountParser_1.bnToBigInt; } });
Object.defineProperty(exports, "bigIntToBn", { enumerable: true, get: function () { return accountParser_1.bigIntToBn; } });
var hooks_1 = require("./hooks");
Object.defineProperty(exports, "Hooks", { enumerable: true, get: function () { return hooks_1.Hooks; } });
/**
 * Derive a PDA from the argued list of seeds.
 * @param {PublicKey} programId
 * @param {AccountSeed[]} seeds
 * @returns {Promise<PublicKey>}
 * @memberof JetClient
 */
function findDerivedAccount(programId, ...seeds) {
    const seedBytes = seeds.map(s => {
        if (typeof s == "string") {
            return Buffer.from(s);
        }
        else if ("publicKey" in s) {
            return s.publicKey.toBytes();
        }
        else if ("toBytes" in s) {
            return s.toBytes();
        }
        else {
            return s;
        }
    });
    const [address] = (0, pubkey_1.findProgramAddressSync)(seedBytes, programId);
    return address;
}
exports.findDerivedAccount = findDerivedAccount;
/**
 * Derive a PDA and associated bump nonce from
 * the argued list of seeds.
 * @param {PublicKey} programId
 * @param {AccountSeed[]} seeds
 * @returns {Promise<DerivedAccount>}
 * @memberof JetClient
 */
function findDerivedAccountWithBump(programId, ...seeds) {
    const seedBytes = seeds.map(s => {
        if (typeof s == "string") {
            return Buffer.from(s);
        }
        else if ("publicKey" in s) {
            return s.publicKey.toBytes();
        }
        else if ("toBytes" in s) {
            return s.toBytes();
        }
        else {
            return s;
        }
    });
    const [address, bump] = (0, pubkey_1.findProgramAddressSync)(seedBytes, programId);
    return { address, bump };
}
exports.findDerivedAccountWithBump = findDerivedAccountWithBump;
/**
 * Create a new client for interacting with the Jet staking program.
 * @param {Provider} provider The provider with wallet/network access that can be used to send transactions.
 * @param {PublicKey} programId
 * @returns {Promise<Program<Idl>>} The client
 * @memberof JetClient
 */
async function connect(programId, provider) {
    const idl = await anchor_1.Program.fetchIdl(programId, provider);
    if (!idl) {
        throw new Error("Program lacks an IDL account.");
    }
    return new anchor_1.Program(idl, programId, provider);
}
exports.connect = connect;
const confirmOptions = {
    skipPreflight: true,
    commitment: "recent",
    preflightCommitment: "recent"
};
/**
 * TODO:
 * @export
 * @param {Connection} connection
 * @param {any} wallet
 * @returns {Provider}
 */
function useProvider(connection, wallet) {
    return (0, react_1.useMemo)(() => new anchor_1.Provider(connection, wallet, confirmOptions), [connection, wallet, confirmOptions]);
}
exports.useProvider = useProvider;
function checkNull(value) {
    if (value === null) {
        throw new Error(`Invalid ${value}`);
    }
}
exports.checkNull = checkNull;
//# sourceMappingURL=index.js.map